// extracted by mini-css-extract-plugin
export var previewContainer = "_sg-0";